export default {"src":"/_next/static/image/public/images/ic_btn_ePharmacy.8a3c9f6a1ee5efd700096a77b480fabc.svg","height":48,"width":48};